import { Node, PropertyOrKeyValue } from "../../Node";
import { PNumber } from "../../properties/PNumber";
import { PBoolean } from "../../properties/PBoolean";

export class CameraNode extends Node {
  near: number;
  far: number;
  fov: number;
  enableDamping: boolean;
  dampingFactor: number;
  // autoRenderDuration: number;
  screenSpacePanning: boolean;

  constructor() {
    super();
    this.near = this.camera.near;
    this.far = this.camera.far;
    this.fov = this.camera.fov;
    this.enableDamping = this.controls.enableDamping;
    this.dampingFactor = this.controls.dampingFactor;
    // this.autoRenderDuration = this.controls.autoRenderDuration;
    this.screenSpacePanning = this.controls.screenSpacePanning;
  }

  get camera() {
    return APP.camera;
  }

  get controls() {
    return APP.controls;
  }

  createProperties() {
    return [
      new PNumber({
        name: "near",
        default: 0.1,
        min: 0.0001,
        max: 1000000,
        decimals: 2,
        slider: false,
        comment:
          "Camera frustum near plane. Default is 0.1.\n" +
          "The valid range is greater than 0 and less than the current value of the far plane. Note that, unlike for the OrthographicCamera, 0 is not a valid value for a PerspectiveCamera's near plane.",
        node: this,
      }),
      new PNumber({
        name: "far",
        default: 2000,
        min: 0,
        max: 1000000,
        decimals: 0,
        slider: false,
        comment:
          "Camera frustum far plane. Default is 2000.\n" +
          "Must be greater than the current value of near plane.",
        node: this,
      }),
      new PNumber({
        name: "fov",
        default: 50,
        min: 0,
        max: 360,
        decimals: 0,
        comment:
          "Camera frustum vertical field of view, from bottom to top of view, in degrees. Default is 50.",
        node: this,
      }),
      { separator: true },
      new PBoolean({
        name: "enableDamping",
        default: true,
        comment:
          "Set to true to enable damping (inertia), which can be used to give a sense of weight to the controls. Default is false.",
        node: this,
      }),
      new PNumber({
        name: "dampingFactor",
        default: 0.08,
        min: 0.00001,
        max: 1,
        decimals: 3,
        comment: "The damping inertia used if .enableDamping is set to true.",
        node: this,
      }),
      // new PNumber({
      //     "name": "autoRenderDuration",
      //     "inputScale": 1000,
      //     "default": 1,
      //     "min": 0,
      //     "max": 60,
      //     "decimals": 0.1,
      //     "comment": "Wie lange werden nach einer Bewegung der Kamera automatisch weitere Frames gerendert? Wichtig für Damping-Animation, da muss der Wert zusammen mit dampingFactor ausprobiert werden und groß genug sein.",
      //     node: this
      // }),
      { separator: true },
      new PBoolean({
        name: "screenSpacePanning",
        default: false,
        comment:
          "Defines how the camera's position is translated when panning. If true, the camera pans in screen space. Otherwise, the camera pans in the plane orthogonal to the camera's up direction. Default is true.",
        node: this,
      }),
    ] as PropertyOrKeyValue[];
  }

  init() {
    super.init();
    this.updateScene();
    return this;
  }

  updateScene() {
    this._dataChanged = {};
    if (this.changed("near") || this.changed("far") || this.changed("fov")) {
      this.camera.near = this.near;
      this.camera.far = this.far;
      this.camera.fov = this.fov;
      this.camera.updateProjectionMatrix();
    }
    if (
      this.changed("enableDamping") ||
      this.changed("dampingFactor") ||
      this.changed("autoRenderDuration") ||
      this.changed("screenSpacePanning")
    ) {
      this.controls.enableDamping = this.enableDamping;
      this.controls.dampingFactor = this.dampingFactor;
      // this.controls.autoRenderDuration = this.autoRenderDuration;
      this.controls.screenSpacePanning = this.screenSpacePanning;
    }
  }

  getName() {
    return "Camera";
  }
}
